import React from 'react';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading';
import Error from '../Components/Error';
import WhatsAppShareButton from '../Components/WhatsAppShareButton';

const CropWiseRecommendations = () => {
  const { data, error, isLoaded } = GetRequest("/Recommendation/GetCropWiseRecommandations");

  if (error !== null) return <Error data="Something went wrong!" />;
  if (!isLoaded) return <Loading />;

  return (
    <div className="container py-4">
      <div>
        <h1 className="text-center my-4 text-success">पीकनिहाय कृषी सल्ला/Crop-wise Recommendations</h1>
        <p className="text-center mb-4 text-muted">
        </p>
      </div>

      <div className="accordion" id="accordionCrops">
        {data.result && data.result.map((cropItem, index) => (
          <div className="accordion-item mb-3" key={cropItem.cropId}>
            <h2 className="accordion-header" id={`headingCrop${cropItem.cropId}`}>
              <button
                className={`accordion-button collapsed ${index % 2 === 0 ? 'gradient-green' : 'gradient-orange'}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapseCrop${cropItem.cropId}`}
                aria-expanded="false"
                aria-controls={`collapseCrop${cropItem.cropId}`}
              >
                {cropItem.cropName}
              </button>
            </h2>
            <div
              id={`collapseCrop${cropItem.cropId}`}
              className="accordion-collapse collapse"
              aria-labelledby={`headingCrop${cropItem.cropId}`}
              data-bs-parent="#accordionCrops"
            >
              <div className="accordion-body">
                <div className="accordion" id={`accordionRec${cropItem.cropId}`}>
                  {cropItem.recommendations.map(recommendation => (
                    <div className="accordion-item mb-2" key={recommendation.id}>
                      <h2 className="accordion-header" id={`headingRec${recommendation.id}`}>
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapseRec${recommendation.id}`}
                          aria-expanded="false"
                          aria-controls={`collapseRec${recommendation.id}`}
                        >
                          <strong>{recommendation.title}</strong> &nbsp;
                          <small>({recommendation.recommendedBy})</small>
                        </button>
                      </h2>
                      <div
                        id={`collapseRec${recommendation.id}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`headingRec${recommendation.id}`}
                        data-bs-parent={`#accordionRec${cropItem.cropId}`}
                      >
                        <div className="accordion-body">
                          <p><strong>Problem:</strong> {recommendation.fieldProblemTitle}</p>
                          <p><strong>Suggestion:</strong> {recommendation.suggestion}</p>
                          {recommendation.moreDetails && (
                            <p><strong>Details:</strong> {recommendation.moreDetails}</p>
                          )}
                          {recommendation.recommendedProductLines?.length > 0 && (
                            <>
                              <strong>Products:</strong>
                              <ul>
                                {recommendation.recommendedProductLines.map(product => (
                                  <li key={product.id}>
                                    {product.productName} - {product.dosageInformationPerAcre || ''} {product.comments && `(${product.comments})`}
                                  </li>
                                ))}
                              </ul>
                            </>
                          )}
                          <WhatsAppShareButton message={recommendation.messageForSharing} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CropWiseRecommendations;
